export enum AssessmentTabs {
    QUESTIONNAIRE = 'Questionnaire',
    MATERIALITY = 'Materiality',
    SUSTAINABLE_DEVELOPMENT_GOALS = 'Sustainable Development Goals',
    CONTROVERSIES_SEARCH = 'Controversies Search',
    COMPANY_PERFORMANCE_DATA = 'Company Performance Data',
}
